export default {"src":"/_next/static/media/Genoa.89dc2439.svg","height":250,"width":176,"blurWidth":0,"blurHeight":0};